
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 341.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0052B4","d":"M0 0h512v341.3H0z"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"260.9","cy":"170.9","r":"118.9"}}),_c('circle',{attrs:{"fill":"none","stroke":"#6DA544","stroke-width":"18","stroke-miterlimit":"10","cx":"261.9","cy":"173.1","r":"94.5"}}),_c('g',{attrs:{"stroke":"#000"}},[_c('path',{attrs:{"fill":"#0052B4","d":"M261.9 151.5l-50.6 23.4v20c0 11.8 6.1 22.8 16.2 28.9L262 239l34.5-15.2c10-6.2 16.2-17.1 16.2-28.9v-20l-50.8-23.4z"}}),_c('path',{attrs:{"fill":"#FFDA44","d":"M211.3 128.1h101.3v46.7H211.3z"}})]),_c('g',{attrs:{"fill":"#BC0029"}},[_c('path',{attrs:{"d":"M0 0h512v35H0zM0 306h512v35H0z"}})])])
          )
        }
      }
    